import { render, staticRenderFns } from "./vdPlayer.vue?vue&type=template&id=f4574c1a&scoped=true&"
import script from "./vdPlayer.vue?vue&type=script&lang=js&"
export * from "./vdPlayer.vue?vue&type=script&lang=js&"
import style0 from "./vdPlayer.vue?vue&type=style&index=0&id=f4574c1a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4574c1a",
  null
  
)

export default component.exports